module.exports = __webpack_public_path__ + "static/img/icon_lianxiwomen.4ed14783.png";